import styled from 'styled-components';
import { CALLER_COLORS as C } from '../tokens';

// Styled-components for the BOOKING HISTORY modal (Figma node 19:9937).
// Columns: DATE / TIME / STAFF / SERVICES / ACTION (TOTAL still not provided by API).
const COLS = '1fr 0.9fr 1.1fr 2.4fr 1.1fr';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  background: #e9f1fd;
  border-bottom: 1px solid ${C.border};
`;
export const HeaderTitle = styled.div`
  color: ${C.navy};
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.6px;
`;
export const HeaderClose = styled.button`
  position: absolute;
  right: 18px;
  background: transparent;
  border: none;
  color: ${C.accentOrange};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
`;

export const CustomerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 14px 22px 6px;
`;
export const Avatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: ${C.avatarBg};
  flex-shrink: 0;
  img {
    width: 14px;
    height: 14px;
  }
`;
export const CusName = styled.span`
  color: ${C.navy};
  font-size: 17px;
  font-weight: 700;
`;
export const CusMeta = styled.span`
  color: ${C.gray};
  font-size: 14px;
`;

export const TableWrap = styled.div`
  padding: 8px 22px 18px;
  overflow-x: auto;
`;
export const Table = styled.div`
  min-width: 640px;
  border: 1px solid ${C.border};
  border-radius: 12px;
  overflow: hidden;
`;
export const HeadRow = styled.div`
  display: grid;
  grid-template-columns: ${COLS};
  background: ${C.navy};
`;
export const HeadCell = styled.div`
  padding: 12px 16px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;
export const BodyRow = styled.div`
  display: grid;
  grid-template-columns: ${COLS};
  align-items: center;
  border-top: 1px solid ${C.border};
`;
export const Cell = styled.div`
  padding: 14px 16px;
  color: ${C.navy};
  font-size: 15px;
`;
export const ServicesCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 12px 16px;
  .svc {
    color: ${C.navy};
    font-size: 15px;
    font-weight: 600;
  }
  .note {
    color: ${C.gray};
    font-size: 13px;
    line-height: 1.4;
  }
`;
export const TotalCell = styled.div`
  padding: 14px 16px;
  color: ${C.navy};
  font-size: 15px;
  font-weight: 700;
`;
export const ActionCell = styled.div`
  padding: 10px 16px;
`;
export const RebookBtn = styled.button`
  background: ${C.orangeSoftBg};
  border: 1px solid ${C.accentOrange};
  border-radius: 8px;
  padding: 8px 16px;
  color: ${C.accentOrange};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;
export const PagerRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 22px 16px;
`;
export const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`;
export const FooterBar = styled.button`
  width: 100%;
  height: 56px;
  background: #e7e9ef;
  border: none;
  color: ${C.navy};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.6px;
  cursor: pointer;
  &:active {
    opacity: 0.85;
  }
`;
